module.exports = __webpack_public_path__ + "img/cofre.e83dff2e.svg";